<template>
  <div :class="'hello ' +  this.$i18n.locale">
    <modal
      height="auto"
      classes="msg-modal"
      width="300px"
      color="#49d663"
      :adaptive="true"
      name="message"
    >{{msg}}</modal>

    <button @click="share()" class="confirm-btn share-btn">
      <img class="icon-logo" src="../assets/img/share.png" alt />
      <span class="icon-logo-text">{{$t('i18nView.share')}}</span>
    </button>

    <img v-if="$i18n.locale === 'zh'" class="top-banner" src="../assets/img/bg.png" alt />

    <img v-else class="top-banner" src="../assets/img/bg-en.png" alt />

    <div class="row what">
      <h3>{{$t('i18nView.whatisForget')}}</h3>
      <p>{{$t('i18nView.whatisForget1')}}</p>
    </div>

    <div class="row newer">
      <h3>{{$t('i18nView.gift')}}</h3>
      <p>
        <span v-html="$t('i18nView.giftTip1')"></span>
        <br />
        <button v-if="!isTP" @click="gotoTp()" class="confirm-btn info">{{$t('i18nView.openintp')}}</button>
        <button v-else-if="!claimed" @click="claim()" class="confirm-btn">
          <span class="icon-logo-text">{{$t('i18nView.claimAndOpen')}}</span>
        </button>
        <button v-else class="confirm-btn disabled">{{$t('i18nView.claimed')}}</button>
      </p>
    </div>

    <div class="row where">
      <h3>{{$t('i18nView.whereis')}}</h3>
      <p>{{$t('i18nView.whereisTip')}}</p>

      <img v-if="$i18n.locale === 'zh'" src="../assets/img/img_cn.png" alt class="where-image" />
      <img v-else src="../assets/img/img_en.png" alt class="where-image" />
    </div>

    <div class="row cpufree">
      <h3>{{$t('i18nView.forgetPro')}}</h3>
      <p>{{$t('i18nView.forgetProTip')}}</p>
      <div class="dapp-wrapper">
        <div class="dapp-item" v-for="dapp in dappList">
          <a :href="dapp.url" target="_blank">
            <img :src="dapp.icon_url" alt />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Eos from "eosjs";
import ScatterJS from "scatterjs-core";
import ScatterEOS from "scatterjs-plugin-eosjs";
import Axios from "axios";

const DOMAIN = "https://preserver.mytokenpocket.vip";

ScatterJS.plugins(new ScatterEOS());

const network = {
  blockchain: "eos",
  host: "eospush.tokenpocket.pro",
  port: 443,
  protocol: "https",
  chainId: "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906",
};

let eosClient = null;
let readOnlyEos = null;
const requiredFields = { accounts: [network] };

var _getCallbackName = function () {
  var ramdom = parseInt(Math.random() * 100000);
  return "tp_callback_" + new Date().getTime() + ramdom;
};

var _sendTpRequest = function (methodName, params, callback) {
  if (window.TPJSBrigeClient) {
    window.TPJSBrigeClient.callMessage(methodName, params, callback);
  }
  // ios
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.shareNewsToSNS
  ) {
    window.webkit.messageHandlers[methodName].postMessage({
      body: {
        params: params,
        callback: callback,
      },
    });
  }
};

_sendTpRequest("fullScreen", JSON.stringify({ fullScreen: 1 }), "");

_sendTpRequest("setMenubar", JSON.stringify({ flag: 1 }), "");

export default {
  name: "HelloWorld",
  data() {
    return {
      isOn: false,
      msg: "",
      AmountLeft: "-",
      currentAccount: null,
      currentPermission: null,
      scatter: null,
      readOnlyEos: null,
      setList: [],
      currentSet: null,
      selectedSet: 0,
      isPaying: false,
      feeUnit: "CNY",
      feeRadio: "0.05",
      hasRam: true,
      quota: "-",
      payee: "self",
      payeeAccount: "",
      referLink: "",
      claimable: false,
      referNum: "-",
      rewardList: [],
      referAccount: "",
      isTP: true,
      claimed: true,
      dappList: [],
    };
  },
  created() {
    let chainId = network.chainId;
    let httpEndpoint =
      network.protocol + "://" + network.host + ":" + network.port;
    if (navigator.userAgent.indexOf("TokenPocket") === -1) {
      this.isTP = false;
    }
    readOnlyEos = Eos({
      chainId,
      httpEndpoint,
    });
    this.getDappList();
    ScatterJS.scatter.connect("newer-gift").then((connected) => {
      // User does not have Scatter Desktop, Mobile or Classic installed.
      if (!connected) return false;
      this.scatter = ScatterJS.scatter;
      this.login();
    });
  },
  methods: {
    login() {
      this.scatter
        .getIdentity(requiredFields)
        .then(() => {
          const account = this.scatter.identity.accounts.find(
            (x) => x.blockchain === "eos"
          );
          let scatter = this.scatter;
          this.currentAccount = account.name;
          this.currentPermission = account.authority;
          eosClient = this.scatter.eos(network, Eos);
          if (_hmt) {
            try {
              _hmt.push([
                "_trackEvent",
                "login",
                this.currentAccount,
                this.$i18n.locale,
              ]);
            } catch (err) {
              console.log(err);
            }
          }
          this.getMyReward();
        })
        .catch((err) => {
          // alert(JSON.stringify(err));
        });
    },
    logout() {
      this.scatter.forgetIdentity();
      this.currentAccount = null;
      this.currentPermission = null;
      this.claimable = false;
      this.referLink = "";
      this.referNum = "-";
    },
    initCopy() {
      var _this = this;
      let clipboard = new ClipboardJS(".copy-btn", {
        text: function () {
          return _this.referLink;
        },
      });
      clipboard.on("success", (e) => {
        _this.showMsg(_this.$t("i18nView.copied"));
      });
      clipboard.on("error", (e) => {
        _this.showMsg(_this.$t("i18nView.copiedFailed"));
      });
    },
    getMyReward() {
      if (this.currentAccount) {
        Axios.get(
          DOMAIN +
            "/v1/account/newbie_reward?blockchain_id=4&account=" +
            this.currentAccount
        ).then((res) => {
          if (res.status === 200 && res.data.result === 0) {
            if (res.data.data > 0) {
              this.claimed = false;
            } else {
              this.claimed = true;
            }
          }
        });
      }
    },
    share() {
      if (this.$i18n.locale === "zh") {
        _sendTpRequest(
          "shareNewsToSNS",
          JSON.stringify({
            title: "EOS账号卡住了？快来免费领取TokenPocket顺畅模式网络费",
            desc: "领取TokenPocket网络费，顺畅无压力",
            url: "https://tp-lab.tokenpocket.pro/new-gift/index.html",
            previewImage: "https://dapp-img.cdn.bcebos.com/chenda/12-10-01.png",
          }),
          ""
        );
      } else {
        _sendTpRequest(
          "shareNewsToSNS",
          JSON.stringify({
            title:
              "Run out of CPU? Come to get some FREE resource in TokenPocket!",
            desc: "Come to get some FREE resource in TokenPocket",
            url: "https://tp-lab.tokenpocket.pro/new-gift/index.html",
            previewImage: "https://dapp-img.cdn.bcebos.com/chenda/12-10-02.png",
          }),
          ""
        );
      }
    },
    copy() {},
    getDappList() {
      Axios.get(
        "https://preserver.mytokenpocket.vip/v1/application/admin_list?start=0&count=50&lang=" +
          (this.$i18n.locale === "zh" ? "zh-Hans" : "en") +
          "&key=&status=-1&category_id=" +
          (this.$i18n.locale === "zh" ? "68" : "69") +
          "&version=10.0.0&dapp_tag=-1"
      ).then((res) => {
        if (res.status === 200 && res.data.result === 0) {
          this.dappList = res.data.data;
        }
      });
    },
    showMsg(msg) {
      this.msg = msg;
      this.$modal.show("message");
    },
    claim() {
      if (this.currentAccount) {
        Axios({
          method: "post",
          url: DOMAIN + "/v1/account/newbie_reward",
          data: "blockchain_id=4&account=" + this.currentAccount,
        })
          .then((res) => {
            if (res.status === 200 && res.data.result === 0) {
              this.setTpState({ useTPResource: 1 }).then((res) => {
                console.log(1);
              });
              this.getMyReward();
              this.showMsg("领取成功");
              if (_hmt) {
                try {
                  _hmt.push([
                    "_trackEvent",
                    "claim",
                    this.currentAccount,
                    this.$i18n.locale,
                  ]);
                } catch (err) {
                  console.log(err);
                }
              }
            }
          })
          .catch((err) => {
            this.handleError(err);
            if (_hmt) {
              try {
                _hmt.push([
                  "_trackEvent",
                  "error",
                  this.currentAccount,
                  this.$i18n.locale,
                ]);
              } catch (err) {
                console.log(err);
              }
            }
          });
      }
    },
    handleError(err) {
      if (typeof err === "string") {
        try {
          let errJson = JSON.parse(err);
          if (errJson.error && errJson.error.details.length) {
            if (
              errJson.error.details[0].message.indexOf(
                "add unit over threshold"
              ) > -1
            ) {
              this.showMsg(this.$t("i18nView.overThreshold"));
            } else {
              this.showMsg(errJson.error.details[0].message);
            }
          } else if (errJson.error) {
            this.showMsg(errJson.error.what);
          } else {
            this.showMsg(errJson.message || errJson.code || errJson.msg);
          }
        } catch (e) {
          this.showMsg(e);
        }
      } else {
        this.showMsg(err.message || err.type || err.code);
      }
    },
    getState() {
      this.getTpState().then((res) => {
        this.isOn = +res.useTPResource === 1;
      });
    },
    setState() {
      this.setTpState({ useTPResource: this.isOn ? 1 : 0 }).then((res) => {
        console.log(res);
      });
    },
    gotoTp() {
      window.location = "https://www.tokenpocket.pro/?from=new";
    },
    getTpState() {
      return new Promise(function (resolve, reject) {
        var tpCallbackFun = _getCallbackName();
        window[tpCallbackFun] = function (result) {
          result = result.replace(/\r/gi, "").replace(/\n/gi, "");
          try {
            var res = JSON.parse(result);
            resolve(res);
          } catch (e) {
            reject(e);
          }
        };
        _sendTpRequest("getResourceConfig", "", tpCallbackFun);
      });
    },
    setTpState(params) {
      return new Promise(function (resolve, reject) {
        var tpCallbackFun = _getCallbackName();
        window[tpCallbackFun] = function (result) {
          result = result.replace(/\r/gi, "").replace(/\n/gi, "");
          try {
            var res = JSON.parse(result);
            resolve(res);
          } catch (e) {
            reject(e);
          }
        };
        _sendTpRequest(
          "setResourceConfig",
          JSON.stringify(params),
          tpCallbackFun
        );
      });
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);
      if (lang === "en") {
        Settings.defaultLocale = "en-US";
      } else {
        Settings.defaultLocale = "zh-CN";
      }
    },
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.hello {
  position: relative;
  max-width: 480px;
  margin: 0 auto;
}
h3 {
  margin: 4px 0;
  font-size: 15px;
  color: #101010;
}

h5 {
  font-size: 13px;
  color: #9ea0a5;
  margin: 4px;
  font-weight: normal;
}

ul {
  padding: 0;
  margin: 0;
}

li {
  margin: 0;
  padding: 0;
  margin-left: 15px;
  color: #9ea0a5;
  line-height: 1.5;
  margin-bottom: 8px;
}

.divider {
  height: 12px;
}
hr {
  margin: 0;
  padding: 0;
  border: none;
  border-top: 1px solid #f1f1f1;
}

.row {
  font-size: 14px;
  margin: 0 16px;
  line-height: 2;
  padding: 8px 0 16px;
  background-color: #fff;
  border-bottom: 1px dashed #eee;

  &:last-child {
    border: none;
    margin-bottom: 16px;
  }
}
.set {
  display: inline-block;
  width: 100%;
  margin: 4px 0;
}

.top-banner {
  width: 100%;
  height: 280px;
}

.well {
  margin: 0;
  box-sizing: border-box;
  padding: 16px;
  line-height: 1.5;
  background: #f6f6f6;
  font-size: 14px;
  color: #888;
  border-radius: 4px;
}

.amount {
  font-weight: bold;
  text-align: right;
  line-height: 1.2;

  span {
    color: #888;
    font-size: 12px;
  }
}

.align-right {
  float: right;
  top: 5px;
  margin-left: 10px;
}

.set-wrap {
  input[type="radio"] {
    display: none;

    & + span {
      position: relative;
      display: block;
      padding: 4px 0 2px 20px;
      box-sizing: border-box;
      border: 1px solid #e2e2e2;
      border-radius: 6px;
      text-align: left;
    }
  }

  input[type="radio"]:checked + span {
    border-color: #2980fe;

    &:after {
      position: absolute;
      content: "";

      bottom: 0;
      background: url("../assets/select.png");
      right: 0;
      width: 30px;
      height: 30px;
      background-size: 100%;
    }
  }
}

.icon-logo {
  width: 16px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 4px;
}

.icon-logo-text {
  display: inline-block;
  vertical-align: middle;
}

.buy-icon {
  width: 26px;
  height: 26px;
}

.fee-tips {
  font-size: 13px;
  color: #666;
  padding-bottom: 20px;
}

.times {
  font-size: 15px;
  line-height: 1.5;
}
.price {
  font-size: 14px;
  position: relative;
  color: #999;
  line-height: 1.5;
}

.symbol-tpt {
  position: relative;

  &:before {
    content: "";
    display: block;
    position: absolute;
    width: 26px;
    height: 20px;
    border-radius: 5px;
    left: 97px;
    top: 7px;
    background-repeat: no-repeat;
    background-size: 100%;
  }
}
.refer-link.input-text {
  border-radius: 4px 0 0 4px;
}
.payee-wrap {
  input {
    display: inline-block;
    margin: 0;
    vertical-align: middle;
    padding: 0;

    + span {
      vertical-align: middle;
      display: inline-block;
      margin: 0 12px 0 6px;
    }
  }
}

.pay-show {
  position: absolute;
  right: 12px;
  top: 16px;
}

.input-text {
  width: 100%;
  padding: 8px 12px;
  box-sizing: border-box;
  background-color: #f5f6f7;
  color: #333;
  border-radius: 4px;
  border: none;
  line-height: 1.5;
  font-size: 14px;
}

.read-only {
  color: #888;
}

.copy-btn {
  position: absolute;
  width: 80px;
  right: -80px;
  background: #dceaff;
  color: #2980fe;
  border: none;
  top: 0;
  padding: 10px 12px;
  border-radius: 0 4px 4px 0;
}
a {
  color: #2980fe;
}
.confirm-wrap {
  padding-bottom: 20px;
}

.refer-wrap {
  li {
    font-size: 13px;
  }
}

.claim-wrap {
  text-align: center;

  button {
    padding: 6px;
    background: #2980fe;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    min-width: 120px;
    border: none;
    outline: none;
    margin: 8px 0;
  }
}

.where-image {
  width: 100%;
}

.red-error {
  color: #ea4257;

  span {
    color: #ea4257;
  }
}

p {
  position: relative;
  color: #666;
  font-size: 12px;
  margin: 0;
  padding-left: 8px;

  &:before {
    content: "";
    position: absolute;
    background: #ddd;
    left: 0;
    top: 10px;
    display: block;
    width: 4px;
    height: 4px;
    border-radius: 4px;
  }
}

.reward-item {
  padding: 10px 0;
  box-sizing: border-box;
  display: inline-block;
  width: 46%;
  margin: 0 2%;
  text-align: center;
  font-size: 15px;
  color: #3a3b3d;
}

div.newer {
  h3 {
    color: #2674fd;
    display: inline-block;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      display: block;
      width: 36px;
      height: 17px;
      background: url("../assets/img/gift.png") no-repeat;
      background-size: 100%;
      right: -44px;
      top: 6px;
    }
  }

  em {
    color: #2674fd;
    font-style: normal;
  }

  p {
    &:before {
      background: #2674fd;
    }
  }
}

.row.what {
  margin-top: -80px;
}

.dapp-wrapper {
  overflow: hidden;
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 4px 10px;
  margin: 8px 0;
}

.dapp-item {
  display: inline-block;
  width: 20%;
  padding: 8px;
  line-height: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;

  img {
    width: 100%;
    border-radius: 12px;
    border: 2px solid #fff;
    box-shadow: 0 1px 4px 0px #ddd;
  }
}

.confirm-btn {
  border-radius: 20px;
  font-size: 13px;
  background: #2674fd;
  color: #fff;
  -webkit-appearance: none;
  border: none;
  line-height: 1.5;
  padding: 4px 10px;
  margin: 8px 0;

  &.disabled {
    background: #dddddd !important;
    color: #fff;
  }

  &.info {
    background: #338afd;
  }
}

.share-btn {
  background: #fff;
  color: #019f43;
  position: absolute;
  padding: 3px 8px;
  top: 8px;
  right: 20px;

  .icon-logo {
    width: 13px;
  }
}

@media screen and (max-width: 350px) {
  .top-banner {
    width: 100%;
    height: 260px;
  }
}
</style>
